import * as React from "react";
import { Modal } from 'react-bootstrap';
import closeIcon from '../assets/images/cross-close.svg';

const { useState } = React;

export const EmailPreviewModal = ({ show, close, htmlContent }) => {
    //console.log(htmlContent);

    return (
        <Modal show={show} onHide={close} className="modalStyle p-0 email-preview-backdrop" size="lg">
            <Modal.Body className="p-4">
                <div className="d-flex justify-content-end mb-3">
                    <img src={closeIcon} onClick={close} className="cursor-pointer" alt="close" />
                </div>

                <p className="mb-0"> <span className="fw-bold">Email: </span> <span>{htmlContent.EmailTo}</span> </p> 
                <p className="mb-4"> <span className="fw-bold">Subject: </span> <span>{htmlContent.EmailSubject}</span> </p>

                {/* Render the raw HTML string */}
                <div dangerouslySetInnerHTML={{ __html: htmlContent.EmailBody }} />
            </Modal.Body>
        </Modal>
    );
};
